import "./App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import LoginPage from "./pages/Login/Login";
import ProtectedLayout from "./components/Layout/ProtectedLayout";
import UsersList from "./pages/Users/usersList";
import { AuthProvider } from "./AuthContext/AuthContext";
import LocalPagamento from "./pages/LocalPagamento/localPagamento";
import ContribuintesList from "./pages/Contribuinte/listarContribuinte";
import ContribuinteTabs from "./pages/Contribuinte/MenuPages/ContribuinteTabs";
import { GlobalStyle } from "./shared/global/style.global";
import CaixaPage from "./pages/Caixa/Caixa";
import Remessas from "./pages/Remessa/remessa";
import Lotacao from "./pages/Lotacao/lotacao";
import FormaPagamento from "./pages/FormaPagamento/formaPagamento";
import InstrucaoBancaria from "./pages/InstrucaoBancaria/instrucaoBancaria";
import RelatoriosGerenciais from "./pages/RelatoriosGerenciais/relatorios";
import AcessoNegado from "./pages/AcessoNegado/acessoNegado";
import ConsultaRapida from "./pages/ConsultaRapida/consultaRapida";
import ReajusteValoresFinanceiros from "./pages/ReajusteValoresFinanceiros/ReajusteValoresFinanceiro";
import CadastrosGerais from "./pages/CadastrosGerais/cadastroGerais";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <GlobalStyle />
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            {/* Página de Login sem sidebar */}
            <Route path="/" element={<LoginPage />} />

            {/* Páginas protegidas com sidebar */}
            <Route element={<ProtectedLayout />}>
              <Route path="/consulta-rapida" element={<ConsultaRapida />} />
              <Route
                path="/list-contribuinte"
                element={<ContribuintesList />}
              />
              <Route path="/contribuinte" element={<ContribuinteTabs />} />
              <Route path="/cadastros-gerais" element={<CadastrosGerais />} />
              <Route
                path="/reajuste-parcelas"
                element={<ReajusteValoresFinanceiros />}
              />
              <Route path="/caixa" element={<CaixaPage />} />
              <Route path="/remessas" element={<Remessas />} />
              <Route
                path="/relatorios-gerenciais"
                element={<RelatoriosGerenciais />}
              />
              <Route path="/list-users" element={<UsersList />} />
              <Route path="/acesso-negado" element={<AcessoNegado />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
